import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Programas from "../pages/programas/page";
import GuiaSenalesSueno from "../pages/guia-senales-sueno/page";
import RutinaRelajacion from "../pages/rutina-relajacion/page";
import YogaDormirSecuenciaNocturna from "../pages/yoga-dormir-secuencia-nocturna/page";
import AmbienteIdealSueno from "../pages/ambiente-ideal-sueno/page";
import RegresionesSueno from "../pages/regresiones-sueno/page";
import MeditacionMamasCansadas from "../pages/meditacion-mamas-cansadas/page";
import FundamentosSueno from "../pages/fundamentos-sueno/page";
import YogaSuenoProfundo from "../pages/yoga-sueno-profundo/page";
import ProgramaCompletoNeurobabys from "../pages/programa-completo-neurobabys/page";
import AlbumNanasDelUtero from "../pages/album-nanas-del-utero/page";
import AlbumLunaDeMiel from "../pages/album-luna-de-miel/page";
import AlbumOndasDeCalma from "../pages/album-ondas-de-calma/page";
import AlbumFrecuenciasDelCerebro from "../pages/album-frecuencias-del-cerebro/page";
import AlbumDespertarSuave from "../pages/album-despertar-suave/page";
import AlbumRitualNocturno from "../pages/album-ritual-nocturno/page";
import TuValorActivo from "../pages/tu-valor-activo/page";
import EncuentrosConTuFortaleza from "../pages/encuentros-con-tu-fortaleza/page";
import MaternidadSagrada from "../pages/maternidad-sagrada/page";
import ElAmparoDeTuPropiaCabeza from "../pages/el-amparo-de-tu-propia-cabeza/page";
import ElManantialInterior from "../pages/el-manantial-interior/page";
import ElReflejoLuminoso from "../pages/el-reflejo-luminoso/page";
import ConoceAMercedes from "../pages/conoce-a-mercedes/page";
import QuieroCambiar from "../pages/quiero-cambiar/page";
import ConoceElMetodo from "../pages/conoce-el-metodo/page";
import Audiolibros from "../pages/audiolibros/page";
import TestSueno from "../pages/test-sueno/page";
import CapitulosDormirTranquila from "../pages/capitulos-dormir-tranquila/page";
import ColeccionCompletaDormirTranquila from "../pages/coleccion-completa-dormir-tranquila/page";
import ColeccionCompletaMusica from "../pages/coleccion-completa-musica/page";
import ColeccionBestSellers from "../pages/coleccion-best-sellers/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/programas",
    element: <Programas />,
  },
  {
    path: "/audiolibros",
    element: <Audiolibros />,
  },
  {
    path: "/test-sueno",
    element: <TestSueno />,
  },
  {
    path: "/capitulos-dormir-tranquila",
    element: <CapitulosDormirTranquila />,
  },
  {
    path: "/coleccion-completa-dormir-tranquila",
    element: <ColeccionCompletaDormirTranquila />,
  },
  {
    path: "/coleccion-completa-musica",
    element: <ColeccionCompletaMusica />,
  },
  {
    path: "/coleccion-best-sellers",
    element: <ColeccionBestSellers />,
  },
  {
    path: "/guia-senales-sueno",
    element: <GuiaSenalesSueno />,
  },
  {
    path: "/rutina-relajacion",
    element: <RutinaRelajacion />,
  },
  {
    path: "/yoga-dormir-secuencia-nocturna",
    element: <YogaDormirSecuenciaNocturna />,
  },
  {
    path: "/ambiente-ideal-sueno",
    element: <AmbienteIdealSueno />,
  },
  {
    path: "/regresiones-sueno",
    element: <RegresionesSueno />,
  },
  {
    path: "/meditacion-mamas-cansadas",
    element: <MeditacionMamasCansadas />,
  },
  {
    path: "/fundamentos-sueno",
    element: <FundamentosSueno />,
  },
  {
    path: "/yoga-sueno-profundo",
    element: <YogaSuenoProfundo />,
  },
  {
    path: "/programa-completo-neurobabys",
    element: <ProgramaCompletoNeurobabys />,
  },
  {
    path: "/album-nanas-del-utero",
    element: <AlbumNanasDelUtero />,
  },
  {
    path: "/album-luna-de-miel",
    element: <AlbumLunaDeMiel />,
  },
  {
    path: "/album-ondas-de-calma",
    element: <AlbumOndasDeCalma />,
  },
  {
    path: "/album-frecuencias-del-cerebro",
    element: <AlbumFrecuenciasDelCerebro />,
  },
  {
    path: "/album-despertar-suave",
    element: <AlbumDespertarSuave />,
  },
  {
    path: "/album-ritual-nocturno",
    element: <AlbumRitualNocturno />,
  },
  {
    path: "/tu-valor-activo",
    element: <TuValorActivo />,
  },
  {
    path: "/encuentros-con-tu-fortaleza",
    element: <EncuentrosConTuFortaleza />,
  },
  {
    path: "/maternidad-sagrada",
    element: <MaternidadSagrada />,
  },
  {
    path: "/el-amparo-de-tu-propia-cabeza",
    element: <ElAmparoDeTuPropiaCabeza />,
  },
  {
    path: "/el-manantial-interior",
    element: <ElManantialInterior />,
  },
  {
    path: "/el-reflejo-luminoso",
    element: <ElReflejoLuminoso />,
  },
  {
    path: "/conoce-a-mercedes",
    element: <ConoceAMercedes />,
  },
  {
    path: "/conoce-el-metodo",
    element: <ConoceElMetodo />,
  },
  {
    path: "/quiero-cambiar",
    element: <QuieroCambiar />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;